<template>
    <div>

  <div class="d-flex justify-space-between mb-5 ">
    <div>
      <div class="page-title mb-2">แบบฟอร์มคำร้องขอใช้บริการพื้นที่ทั้งหมด</div>
      <div class="d-flex align-center">
        <Iconify
          icon="bxs:message-square-detail"
          color="var(--theme-color-seven)"
          class="mr-3"
        ></Iconify>
      <div class="">แบบฟอร์มคำร้องขอใช้บริการพื้นที่ที่ส่งยื่นทั้งหมด</div>
      </div>
    </div>
    <div class="d-flex flex-column gap-12">
      <div class="d-flex gap-12">
        <div class="flex-center gap-8" style="max-width: 250px">
          <div class="min-width-max">สถานะ</div>
          <SelectBox
            placeholder="สถานะ"
            hide-details
            clearable
            :items="statusMaster"
            item-text="label"
            item-value="value"
            @onChange="
              searchData.status = $event;
              getAllForms();
            "
          ></SelectBox>
        </div>

        <div style="max-width: 250px">
          <TextField
            hide-details
            placeholder="ค้นหา"
            append-inner-icon="search"
            @onChange="searchData.keyword = $event"
            @onEnter="getAllForms()"
          ></TextField>
        </div>
      </div>
      <div class="d-flex justify-end">
        <Button @onClick="formConsider" :disabled="isButtonDisabled" 
        :theme="isButtonDisabled ? 2 : 1"
        
        >ยื่นพิจารณา </Button>
      </div>
    </div>
 
    </div>
    <div>
    <div class="d-flex justify-space-between table-head">
    <div
        v-for="(item, i) in tableHeader"
        :key="i"
        :style="{ width: item.width }"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="list-layout">
      <div v-for="(item, i) in requestList" :key="i">
        <!-- v-if="item.status !== 'Submitted'" -->
        <RowCard
          :key="i"
          :multiLine="true"
          :theme="getColor(item?.status)"
        >
        <div 
        :style="{ width: tableHeader[0].width }"
        class='d-flex  mr-4  align-center items-center'>
          <CheckBox class=" mr-n1"
            :disabled='item.status !== "Submitted"'
            :input-value="checkId.includes(item.id)"
            @onChange="onChecked($event,item.id)"
          ></CheckBox>
          <v-btn 
        v-show="item.status !== 'Submitted'"
          small
          icon
          class="edit-icon-class"
          @click="onPreview(item.id)"
        >
          <Iconify icon="material-symbols:visibility" color="var(--theme-color-seven)" size="18px"></Iconify>
        </v-btn>
          <v-btn
          v-show="item.status === 'Submitted'"
          small
          icon
          class='mt-n1'
          @click="onEdit(item.id)"
        >
          <Iconify 
          class='' icon="material-symbols:edit" color="var(--theme-color-seven)" size="18px"></Iconify>
        </v-btn>

        <v-btn
          v-if="item.status === 'Approved' && item.approved_at && item.approved_at.trim() && !item.exit_at"
          small
          icon
          class='mt-n1'
          :disabled='item?.exit_at !== null'

         @click="item?.exit_at === null && onStamp(item.id)"
        >
        <Iconify 
        :disabled='item?.exit_at !== null'

        icon="material-symbols:approval" color="var(--theme-color-seven)" size="18px"></Iconify>
        </v-btn>


        </div>
          <div :style="{ width: tableHeader[1].width }">{{ item.no ?? "-" }}</div>
          <div :style="{ width: tableHeader[2].width }">
            <div>
              {{ item?.area_form_2?.company_name_th }}
              </div>
            <div class='py-2' >
                วันที่อนุมัติ : {{ dateFormatting(item?.approved_at) ?? '-' }}
              </div>
              <div>
                วันที่ออก : {{ dateFormatting(item?.exit_at) ?? '-' }}
              </div>
          </div>
          <div :style="{ width: tableHeader[3].width }">
            {{ item?.created_by ?? "-" }}
            
          </div>
          <div :style="{ width: tableHeader[4].width }">
            {{ toDateFormat(item?.sent_at) }}

          </div>
          <div :style="{ width: tableHeader[5].width }">
            <div  
              class=" font-type-normal status_text "
             :class="[ 'text-theme-' + getColor(item?.status) ]"
              >
              {{ getStatus(item?.status) }}
            </div>
          </div>
          <!-- <div
            :style="{ width: tableHeader[6].width }"
            :class="item.status === 'Submitted' ? 'txt__green' : 'txt__black'"
          >
            {{ item.status }}
          </div> -->
        </RowCard>
      </div>

      <v-pagination
        class="mt-6"
        v-model="paginate.current_page"
        :length="paginate.last_page"
        color="#DE7033"
        @input="getAllForms"
      ></v-pagination>
    </div>
  </div>
  </div>
</template>

<script>
import TextField from "@/components/input/TextField";
import SelectBox from "@/components/input/SelectBox";
import Button from "@/components/input/Button";
import RowCard from "@/components/RowCard";
import CheckBox from "@/components/input/CheckBox";
import { mapState } from "vuex";
import { toDateFormat, formatNumber } from "@/plugins/global-funcs";
import { quartersInYear } from "date-fns";

export default {
  components: {
    TextField,
    SelectBox,
    Button,
    CheckBox,
    RowCard
  },
  data() {
    return {
      toDateFormat,
      tableHeader: [
        {
          name: "เลือก",
          width: "6%",
        },
        {
          name: "เลขที่",
          width: "12%",
        },
        {
          name: "แบบฟอร์ม",
          width: "28%",
        },
        {
          name: "ผู้นำเข้าข้อมูล",
          width: "24%",
        },
        {
          name: "วันที่ยื่น",
          width: "14%",
        },
        {
          name: "สถานะ",
          width: "10%",
        },
      ],
      statusMaster: [{label:"รอยื่นพิจารณา",
        value:"Submitted"}
      , {label:"รอพิจารณา",
      value:"In Review"}, {label:"ผ่านเกณฑ์พิจารณา",
      value:"Approved"}, {label:"ไม่ผ่านเกณฑ์พิจารณา",
      value:"Rejected"}],
      searchData: {
        status: null,
        keyword: null,
      },
      requestList: [],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
      checkId:[],
    };
  },
  created() {
    this.getAllForms();
    
  },
  computed: {
    isButtonDisabled() {
      return !this.checkId.length > 0;
    },
    ...mapState({
      userName: (state) => state.Auth.User?.id,
    }),
  },
  methods: {
    async getAllForms(page) {
      let payload = {
        page: page ?? this.paginate.current_page,
        // per_page: 1,
        status: this.searchData.status ?? "Rejected,In Review,Submitted,Approved",
        keyword: this.searchData.keyword,
      };

      let res = await this.$apiFire("Request/getSpaceRequestsAll", payload);
      if (res) {
        console.log(res,'res');
        this.requestList = res.data.map((item, index) => {
          return {
            ...item,
            count: (res.current_page - 1) * res.per_page + index + 1,
            checked: this.checkId.includes(item.id)
          };
        });
        this.paginate = {
          total: res.total,
          per_page: res.per_page,
          current_page: res.current_page,
          last_page: res.last_page,
        };
      }
    },
    async formConsider() {
      const payload = {
        area_form_ids: this.checkId,
      }
      let res = await this.$apiFire("Request/formConsider", payload);
      if (res) {
        this.checkId = []
      this.getAllForms();
      }
    },
    onChecked(event, id){
      console.log(event,'event',id,'id')
      if(event === true){
        if (!this.checkId.includes(id)) {
          this.checkId.push(id);
        }
      }else{
        const index = this.checkId.indexOf(id);
        if (index !== -1) {
          this.checkId.splice(index, 1);
        }
      }
    },
    onPreview(id) {
      this.$router.push({
        path: `/space-requests-management/space-requests-preview/${id}`,
        query: {
          fromAll: true,
        }
      });
    },
    onEdit(id) {
      this.$router.push({
        path: `/space-requests-management/space-requests-form/${id}`,
        query: {
          fromAll: true,
        }
      });
    },
    async onStamp(id) {
      let res = await this.$apiFire("Request/onStamp", id);
      console.log('res',res)
      if(res.data){
        window.location.reload();
      }
    },
    getStatus(status) {
      if (status === 'Submitted') {
        return "รอยื่นพิจารณา";
      }else if (status === 'In Review') {
        return "รอพิจารณา";
      }else if (status === 'Approved') {
        return "ผ่านเกณฑ์พิจารณา";
      }else if (status === 'Rejected') {
        return "ไม่ผ่านเกณฑ์พิจารณา";
      }else{
        return "";
      }
    },
    getColor(status) {
      if (status === 'Submitted') {
        return "10";
      }else if (status === 'In Review') {
        return "5";
      }else if (status === 'Rejected') {
        return "4";
      }else if (status === 'Approved') {
        return "3";
      }else{
        return "";
      }
    },
    dateFormatting(dateString) {
      if (!dateString) return "-";
      const date = new Date(dateString);

      const options = {
        day: "numeric",
        month: "long",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      };
      const thaiLocaleDate = new Intl.DateTimeFormat("th-TH", options).format(
        date
      );

      const thaiMonthAbbreviations = {
        มกราคม: "ม.ค.",
        กุมภาพันธ์: "ก.พ.",
        มีนาคม: "มี.ค.",
        เมษายน: "เม.ย.",
        พฤษภาคม: "พ.ค.",
        มิถุนายน: "มิ.ย.",
        กรกฎาคม: "ก.ค.",
        สิงหาคม: "ส.ค.",
        กันยายน: "ก.ย.",
        ตุลาคม: "ต.ค.",
        พฤศจิกายน: "พ.ย.",
        ธันวาคม: "ธ.ค.",
      };
      const [day, month, yearTime] = thaiLocaleDate.split(" ");

      const abbreviatedMonth = thaiMonthAbbreviations[month] || month;

      const year = parseInt(yearTime, 10);

      const time = thaiLocaleDate.split(" ")[4];
      const hour = time.split(":")[0];
      const minute = time.split(":")[1];

      return `${day} ${abbreviatedMonth} ${year} เวลา ${hour}:${minute} น.`;
    },
  },
};
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.txt__black {
  color: var(--theme-color-two);
}
.txt__green {
  color: var(--theme-color-three);
}
.text-theme-1 {
  color: var(--theme-color-one);
}
.text-theme-2 {
  color: var(--theme-color-two);
}
.text-theme-3 {
  color: var(--theme-color-three);
}
.text-theme-4 {
  color: var(--theme-color-four);
}
.text-theme-5 {
  color: var(--theme-color-five);
}
.text-theme-10 {
  color: var(--theme-color-ten);
}
.status_text{
  max-width: 80px;
  text-align: center;
}
</style>
